/**
 * After a production deploy, tabs that are still running the previous
 * bundle can lazily import a route chunk (see `src/app/router.tsx`) whose
 * filename hash no longer exists in the deployed container — the request
 * 404s and Vite's dynamic-import wrapper fires `vite:preloadError` on
 * `window` instead of resolving. Left unhandled, that rejects the lazy
 * import and React blanks the screen.
 *
 * We reload once to pick up the new bundle. A reload is safe even mid-exam:
 * the runner already has resume/recovery, so "reload and resume" beats a
 * permanent blank screen. If a reload was already attempted in the last
 * 60 seconds, the new chunk is presumably still missing (a bad deploy, an
 * offline tab, etc.) — reloading again would just loop, so we let the
 * error propagate instead of suppressing it a second time.
 */
const STORAGE_KEY = 'chunk-reload-at'
const RETRY_WINDOW_MS = 60_000

export function handleStalePreloadError(event: Event): void {
  const lastReloadAt = Number(sessionStorage.getItem(STORAGE_KEY))
  const withinRetryWindow = Number.isFinite(lastReloadAt)
    && lastReloadAt > 0
    && Date.now() - lastReloadAt < RETRY_WINDOW_MS

  if (withinRetryWindow) {
    // Already retried recently and it didn't help — let it throw rather
    // than reload forever.
    return
  }

  sessionStorage.setItem(STORAGE_KEY, String(Date.now()))
  event.preventDefault()
  window.location.reload()
}

export function registerStaleChunkReload(): void {
  window.addEventListener('vite:preloadError', handleStalePreloadError)
}
